import './index.styl';
import _ from 'lodash';
import template from './index.jst';
import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';
import { ErrorsModal, Preloader } from '../../../../utils';

const
	CHANNEL_TRADE = Radio.channel('trade'),
	silent = { silent: true };

/**
 * @description Main controls view which accept to make trades / reverse trade or rollback team.
 */
export class TradeBoard extends View {
	get template() {
		return template;
	}

	get className() {
		return 'trade-board';
	}

	ui() {
		return {
			btn_reverse: '.js-reverse-trade',
			btn_confirm: '.js-confirm-trade',
			btn_remove: '.js-btn-delete-player',
			filter_by_pos: '.js-filter-by-position'
		}
	}

	events() {
		return {
			'click @ui.btn_reverse': 'reverseTrade',
			'click @ui.btn_confirm': 'confirmTrade',
			'click @ui.btn_remove': 'removePlayer',
			'click @ui.filter_by_pos': 'triggerFilterPosition'
		}
	}

	initialize() {
		this.model.set({
			locked_trades: []
		}, silent);
		this.listenTo(CHANNEL_TRADE, 'trade:out:player', this.setTradeOutPlayer);
		this.listenTo(CHANNEL_TRADE, 'trade:in:player', this.setTradeInPlayer);
		this.listenTo(CHANNEL_TRADE, 'trade:swap:player', this.setSwapPlayer);
		this.listenTo(CHANNEL_TRADE, 'trade:change:team', this.rememberTeam);
		this.listenTo(CHANNEL_TRADE, 'data:changed', this.onChangeData);

		this.listenTo(this.model, 'update', this.render);

		this.listenTo(this.model, 'make:trade:success', this.onSuccessTrade);

		this.listenTo(this.model, 'make:trade:errors', errors => {
			Preloader.hide();
			ErrorsModal.show(errors);
		});

		return this;
	}

	onChangeData({ transformed_team, trades }) {
		// trades = []
		// for(let i = 0; i < transformed_team.week_trades_limit; i++){
		// 	trades.push({ is_confirmed: false, swap: [] },)
		// }
		trades = trades.filter(_.identity);
		const locked_trades = _.range(transformed_team.week_trades_limit - trades.length);

		this.model.set({ trades, locked_trades }, silent);
		this.rememberTeam(transformed_team)
			.validateTrades()
			.updateButtonsState()
			.notifyAvailablePositions();

		this.model.trigger('update');

		return this;
	}

	/**
	 * Check for ability to add aditional player to trade
	 * @param side {String} Could be `out` or `in`, depend on what side player should be placed.
	 * @return {boolean}
	 */
	isPossibleMakeTradeTo(side) {
		const trades = this.model.get('trades');
		return _.size(trades.filter(trade => trade[side])) < _.size(trades);
	}
	// eslint-disable-next-line complexity
	setPlayerToTrade(side, player, player_position) {
		if (this.isPossibleMakeTradeTo(side)) {
			if (parseInt(player_position, 10)) {
				player.player_position = player_position;
			}
			const
				trades = this.model.get('trades'),
				tradeIndex = _.findIndex(trades, trade => !trade[side]),
				trade = {
					is_confirmed: false,
					...trades[tradeIndex],
					[side]: player
				};

			if (tradeIndex !== -1) {
				trades[tradeIndex] = trade;
			}
			if(trades.length === 2 && !trades[0].is_confirmed){
				if(trades[0].in && trades[0].out && trades[1].in && trades[1].out){
					const playerOneIn = trades[0].in;
					const playerOneOut = trades[0].out;
					const playerTwoIn = trades[1].in;
					const playerTwoOut = trades[1].out;
  
					const firstTradeCheck = playerOneIn.positions.filter(
						value =>	playerOneOut.positions.includes(value)
					).length > 0;
					const secondTradeCheck = playerTwoIn.positions.filter(
						value => playerTwoOut.positions.includes(value)
					).length > 0;
  
					if(!firstTradeCheck || !secondTradeCheck){
						trades[0].in = playerTwoIn;
						trades[1].in = playerOneIn;
					}
				}
			}
			
    
			this.model.set({ trades }, silent);

			this.validateTrades()
				.updateTeamValue()
				.updateButtonsState()
				.notifyAvailablePositions();

			this.model.trigger('update');
		}

		return this;
	}

	removePlayer(event) {
		const
			trades = this.model.get('trades'),
			$target = $(event.target),
			$parent = $target.closest('.player-cell'),
			{ sideKey, tradeIndex } = $parent.get(0).dataset,
			index = parseInt(tradeIndex, 10),
			is_player_from_team = sideKey === 'out';

		/**
		 * Get removed player
		 */
		const player = trades[index][sideKey];
		/**
		 * Remove player from trade and cleanup all swaps in case this player was from the team
		 */
		delete trades[index][sideKey];

		if (is_player_from_team) {
			_.each(trades, trade => trade.swap = []);

			const other_team_players = trades.map(trade => trade.out).filter(_.identity);

			CHANNEL_TRADE.trigger('remove:trade:out:player', {
				player,
				stay_in_trade: other_team_players
			});
		}
		else {
			CHANNEL_TRADE.trigger('remove:trade:in:player', { player });
		}

		this.model.set({ trades });

		this.validateTrades()
			.updateTeamValue()
			.updateButtonsState()
			.notifyAvailablePositions();

		this.model.trigger('update');
	}

	updateButtonsState() {
		const
			is_locked_action_reverse = !this.model.can_make_reverse,
			is_locked_action_trade = !this.model.get('is_valid_trade');

		this.model.set({
			is_locked_action_reverse,
			is_locked_action_trade
		}, silent);

		return this;
	}

	notifyAvailablePositions(){
		CHANNEL_TRADE.trigger(
			'trade:team:available:positions',
			this.model.availbale_trade_spot_size
		);

		return this;
	}

	validateTrades() {
		let validation_state = {
			is_invalid_trade: false,
			is_valid_trade: false,
			trade_error: ''
		};

		if (this.model.is_success_trade_combination) {
			const
				is_remaining_salary_valid = this.model.is_remaining_salary_valid,
				is_positions_valid = this.model.is_trade_positions_valid,
				is_valid_trade = is_remaining_salary_valid && is_positions_valid;

			let trade_error = '';

			if (!is_remaining_salary_valid) {
				trade_error = '' +
					'Your Remaining Salary is negative. ' +
					'Please select a player to Trade Out from ' +
					'your team to finance this trade';
			}

			if (!is_positions_valid) {
				trade_error = 'Trade combination is invalid';
			}

			validation_state = {
				is_invalid_trade: !is_valid_trade,
				is_valid_trade,
				trade_error
			};
		}

		this.model.set(validation_state, silent);

		return this;
	}

	rememberTeam(team) {
		if(team.week_trades_limit === 4){
			this.model.set({ is_show_trade_notice: true }, silent); 
		}
		this.model.set({ team }, silent);

		return this.updateTeamValue();
	}

	updateTeamValue() {
		const
			team_value = this.model.team_value,
			params = {
				team_value,
				remaining_salary: this.model.get('team').salary_cap - team_value
			};

		CHANNEL_TRADE.trigger('trade:team:value:update', params);

		this.model.set(params, silent);
		this.model.trigger('update');

		return this;
	}

	setTradeOutPlayer({ player, team, player_position }) {
		return this.rememberTeam(team)
			.setPlayerToTrade('out', player, player_position);
	}

	setTradeInPlayer(player) {
		this.setPlayerToTrade('in', player)
			.validateTrades()
			.updateTeamValue()
			.updateButtonsState()
			.notifyAvailablePositions();

		this.model.trigger('update');

		return this;
	}

	setSwapPlayer({ player, team }) {
		this.rememberTeam(team);
		this.model.setSubstitutePlayer(player.id);
		this.validateTrades()
			.updateTeamValue()
			.updateButtonsState()
			.notifyAvailablePositions();

		this.model.trigger('update');
	}

	reverseTrade() {
		const trades = this.model.confirmed_trades;
		this.trigger('show:reverse:popup', { trades });
	}

	/**
	 * Confirm trade method
	 * @param event Click event object
	 * @return {Promise.<*>}
	 */
	async confirmTrade() {
		Preloader.show();

		await this.model.makeTrade();
	}

	onSuccessTrade(result) {
		CHANNEL_TRADE.trigger('success:trade', { team: _.first(result) });
	}

	triggerFilterPosition(event) {
		const $target = $(event.target),
			{ position } = $target.data();

		if (position) {
			CHANNEL_TRADE.trigger('filter:by:position', position);
		}
	}
}

export default TradeBoard;